import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addSalarySlip = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Salary Slip',
    body
  );
  return data;
});
export const updateSalarySlip = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Salary Slip/${id}`,
    body
  );
  return data;
});

export const getSalarySlip = catchAsync(async ({key="",value=""}) => {
  let baseUrl = '/api/resource/Salary Slip?fields=["name","docstatus","department","status","employee_name","posting_date","payment_days","net_pay"]&order_by=name desc&limit_start=0&limit_page_length=0'
  if(value){
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
  );
  return data;
});
export const deleteSalarySlip = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Salary Slip/${record}`
  );
  return data;
});
export const getSalarySlipById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Salary Slip/${id}`
  );
  return data;
});
export const getEmployeeAdvanceInfo = catchAsync(async (body) => {
  // console.log(body, 'employeevvvvvvvvvvvvvvvvvvbbbbbbbbbbbbbbbb');
  
  const { data } = await axiosInstance.get(
    `/api/resource/Employee Advance?fields=["name","posting_date","paid_amount","claimed_amount","return_amount","advance_account"]&filters=[["status","=","paid"],["employee","=","${body.employee}"]]`
  );
  return data;
});